import React from "react";
import { NavLink, Outlet } from "react-router-dom";

const tabClass = ({ isActive }) =>
  [
    "px-3 py-2.5 text-sm font-semibold rounded-t-lg border-b-2 -mb-px transition-colors",
    isActive
      ? "border-violet-700 text-violet-900 bg-violet-50/80"
      : "border-transparent text-slate-600 hover:text-violet-800 hover:bg-violet-50/40",
  ].join(" ");

const HubMedAdminLayout = () => (
  <div className="w-full max-w-7xl mx-auto h-full min-h-0 flex flex-col">
    <nav
      className="flex-shrink-0 flex flex-wrap gap-1 border-b border-slate-200 mb-1"
      aria-label="HubMed admin sections"
    >
      <NavLink to="/hubmed-admin/overview" className={tabClass}>
        Overview
      </NavLink>
      <NavLink to="/hubmed-admin/onboarding" className={tabClass}>
        Prospective Chemists
      </NavLink>
      <NavLink to="/hubmed-admin/practitioner-settings" className={tabClass}>
        Practitioner settings
      </NavLink>
      <NavLink to="/hubmed-admin/pricing-settings" className={tabClass}>
        Pricing settings
      </NavLink>
      <NavLink to="/hubmed-admin/hubmed-linking" className={tabClass}>
        HubMed linking
      </NavLink>
      <NavLink to="/hubmed-admin/reports" className={tabClass}>
        Reports
      </NavLink>
      <NavLink to="/hubmed-admin/bulk-billed-pricing" className={tabClass}>
        Bulk billed pricing
      </NavLink>
    </nav>
    <div className="flex-1 min-h-0 min-w-0 flex flex-col">
      <Outlet />
    </div>
  </div>
);

export default HubMedAdminLayout;
